<template>
  <v-data-table
    :headers="tabela.headers"
    :items="relatoriosUnidades"
    :search="tabela.opcoes.pesquisa"
    :sort-by="tabela.opcoes.ordenarPor"
    :sort-desc="tabela.opcoes.decrescente"
  >
    <!-- Ordenação e Pesquisa -->
    <template v-slot:top>
      <v-row>
        <v-col cols="12" md="4">
          <app-sort v-model="tabela.opcoes" />
        </v-col>
        <v-spacer />
        <v-col cols="12" md="4">
          <app-search v-model="tabela.opcoes" />
        </v-col>
      </v-row>
    </template>

    <!-- Total -->
    <template v-slot:[`body.append`]>
      <tr>
        <td align="center" colspan="2">
          <strong class="subtitle-2 grey--text text--darken-2">TOTAL</strong>
        </td>
        <td v-for="idioma in relatorio.idiomas" :key="idioma.id" align="center">
          <strong>{{ idioma.quantidade }}</strong>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import { normalizar } from '@/modules/texto';

export default {
  name: 'TabelaResultadoGeralFormacaoIdioma',

  components: {
    AppSort,
    AppSearch,
  },

  props: {
    relatorio: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data() {
    return {
      tabela: {
        headers: [
          {
            text: 'UNIDADE',
            value: 'nome',
            sortable: false,
          },
          {
            text: 'SIGLA',
            value: 'sigla',
            sortable: false,
          },
          ...this.relatorio.idiomas.map((i) => ({
            text: i.nome.toUpperCase(),
            value: normalizar(i.nome),
            sortable: false,
            align: 'center',
          })),
        ],
        opcoes: {
          pesquisa: '',
          decrescente: false,
          ordenarPor: 'nome',
          selecionado: { id: 'nome', descricao: 'Nome da Unidade' },
          lista: [
            { id: 'nome', descricao: 'Nome da Unidade' },
            { id: 'sigla', descricao: 'Sigla da Unidade' },
            ...this.relatorio.idiomas.map((i) => ({
              id: normalizar(i.nome),
              descricao: i.nome,
            })),
          ],
        },
      },
    };
  },

  computed: {
    relatoriosUnidades() {
      return this.relatorio.unidades.map((rU) => {
        const idiomas = {};
        rU.idiomas.forEach((i) => {
          idiomas[normalizar(i.nome)] = i.quantidade;
        });

        return {
          nome: rU.nome,
          sigla: rU.sigla,
          ...idiomas,
        };
      });
    },
  },
};
</script>
